import { render } from "./BetButton.vue?vue&type=template&id=68db138e&scoped=true"
import script from "./BetButton.vue?vue&type=script&lang=js"
export * from "./BetButton.vue?vue&type=script&lang=js"

import "./BetButton.vue?vue&type=style&index=0&id=68db138e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68db138e"]])

export default __exports__